import { LoadingLine } from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { IInjectedRootStore } from 'stores';
import * as S from './private-route.styles';

interface IPrivateRouteState {
    verified: boolean;
}

@inject('rootStore')
@observer
export class PrivateRoute extends React.Component<RouteProps, IPrivateRouteState> {
    constructor(props: RouteProps) {
        super(props);
        this.state = {
            verified: false,
        };
    }
    public render(): React.ReactElement {
        const rest = _.omit(this.props, 'component');
        return this.state.verified ? (
            <Route {...rest} render={this.renderComponentOrRedirect} />
        ) : (
            this.renderProgress()
        );
    }
    public async componentDidMount(): Promise<void> {
        await this.injected.rootStore.checkSession();
        this.setState({ verified: true });
    }
    private get injected(): IInjectedRootStore {
        return this.props as IInjectedRootStore;
    }
    private get isExpired(): boolean {
        return this.injected.rootStore.isExpiredSession();
    }
    private readonly renderComponentOrRedirect = (props: RouteComponentProps<any>): React.ReactElement => {
        const Component: React.ComponentType<RouteComponentProps<any>> | undefined = this.props.component;
        return !this.isExpired && Component ? <Component {...props} /> : <Redirect to="/redirect" />;
    };
    private readonly renderProgress = (): React.ReactElement => {
        const timeout = 15 * 1000;
        return (
            <S.Progress>
                <LoadingLine timeout={timeout} />
            </S.Progress>
        );
    };
}
